import { MutationStatus /* , useQueryClient */ } from '@tanstack/react-query';
import { PostQuestionnairePayload } from 'api/typegen/client/questionnaire/post';
import { PostRegistrationResponse } from 'api/typegen/registration/post';
import postQuestionnaireApiCall from 'api/calls/postQuestionnaireApiCall';
import useProtectedMutation from './useProtectedMutation';

interface UseCreateRegistrationMutation {
  status: MutationStatus;
  postQuestionnaire: (payload: PostQuestionnairePayload) => Promise<void>;
  data?: PostRegistrationResponse;
}

const useQuestionnaireMutation = (): UseCreateRegistrationMutation => {
  // const queryClient = useQueryClient();
  const mutation = useProtectedMutation(
    (payload: PostQuestionnairePayload) => postQuestionnaireApiCall(payload),
    // {
    //   onSuccess: () => {
    //     queryClient.invalidateQueries(['getValidAMLExistsApiCall']);
    //   },
    // },
  );

  return {
    status: mutation.status,
    postQuestionnaire: mutation.mutateAsync,
  };
};

export default useQuestionnaireMutation;
